export default "__VITE_ASSET__92a391c8__"